import { generatePath } from 'react-router-dom';
import {
  FolderManagerItemActionNames,
  FolderManagerItemActionTypes,
  FolderManagerItemTypes,
  FolderManagerMimeTypes,
} from '../interfaces';
import { routesNames } from '../routes';

export const excelDataToApiFormat = (formattedData: any, columnLabels?: string[] | null) => {
  // FIXME: this is really to support data without schema, but it should not be handled here
  // even without schema columns should be created in the parent component and passed as columnLabels
  if (!columnLabels) {
    // Extract keys from the first row
    const keys = formattedData[0].map((cell: any) => cell.value);

    // Transform subsequent rows into objects with keys and values
    return formattedData.slice(1).map((row: any) => {
      let obj: any = {};
      row.forEach((cell: any, index: number) => {
        obj[keys[index]] = cell.value;
      });
      return obj;
    });
  }

  return formattedData.map((row: any) => {
    let mappedRow: any = {};
    columnLabels.forEach((col, index) => {
      mappedRow[col] = row[index] && row[index].value ? row[index].value : null;
    });
    return mappedRow;
  });
};

export const getFileNameAndExtensionFromFileName = (filename: string) => {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex !== -1) {
    return {
      name: filename.substring(0, lastDotIndex),
      extension: filename.substring(lastDotIndex + 1),
    };
  }

  return { name: filename, extension: '' };
};

export const simpleSlugify = (string: string) => {
  return string
    .toLowerCase() // Convert to lowercase
    .trim() // Remove leading and trailing spaces
    .replace(/[\s_]+/g, '-') // Replace spaces and underscores with a hyphen
    .replace(/[^\w\-]+/g, '');
};

export const parseSearchInput = (input: string): any => {
  const trimmedInput = input.trim();

  // regex to match quoted strings OR sequences of non-space/non-comma characters
  const regex = /"([^"]*)"|[^,\s]+/g;

  const parts: string[] = [];
  let match;

  while ((match = regex.exec(trimmedInput)) !== null) {
    if (match[1] !== undefined) {
      // Quoted part without the quotes
      parts.push(match[1].trim());
    } else {
      parts.push(match[0]);
    }
  }

  const primaryKeyValues: string[] = [];
  const names: string[] = [];

  parts.forEach((part) => {
    if (/^\d+$/.test(part)) {
      primaryKeyValues.push(part);
    } else {
      names.push(part);
    }
  });

  return [...primaryKeyValues, ...names];
};



export const mapProjectToStore = (item: any): WorkspaceFromStore => {
  return {
    id: item.ID,
    name: item?.DisplayName || item?.Name || 'Unknown',
    type: FolderManagerMimeTypes.FOLDER,
    template: item.ProjectTemplate,
    templateId: item.ProjectTemplateID,
    updatedAt: item?.UpdatedAt,
    createdAt: item?.CreatedAt,
    isShared: item?.IsShared,
    status: item?.Status,
    actions: [
      { name: FolderManagerItemActionNames.EDIT, type: FolderManagerItemActionTypes.SINGLE },
      { name: FolderManagerItemActionNames.SHARE, type: FolderManagerItemActionTypes.SINGLE },
      { name: FolderManagerItemActionNames.RESTORE, type: FolderManagerItemActionTypes.MULTI },
      { name: FolderManagerItemActionNames.DELETE, type: FolderManagerItemActionTypes.MULTI },
    ],
  };
};

export const mapWorkspaceToGalleryItem = ({ item }: { item: any; isShared?: boolean }): WorkspaceGalleryItem => {
  const outputTypes = new Set<string>();

  const documentTemplates = item?.documentTemplates || item?.template?.DocumentTemplates;

  if (documentTemplates) {
    for (const doc of documentTemplates) {
      if (doc?.AllowedOutputTypes) {
        for (const outputType of doc.AllowedOutputTypes) {
          outputTypes.add(outputType.toUpperCase());
        }
      }
    }
  }

  return {
    id: item.id,
    isShared: !!item?.isShared,
    outputTypes: Array.from(outputTypes),
    link: generatePath(routesNames.editProject, { projectId: item.id }),
    displayName: item?.displayName || item?.name,
    type: FolderManagerItemTypes.WORKSPACE,
    features: item?.features || item?.template?.Features,
    status: item?.status,
    actions: item.actions,
    updatedAt: item.updatedAt,
    template: item.template,
  };
};
